/*
 *   Copyright (c) 2022 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */

import { notificationFetchListType, notificationFetchRowUpdateType } from './types'

type propType = Pick<notificationFetchListType['response']['data']['data'][0], 'description'>
export default function getDifference(row: propType) {
  const show = (key: string, value: string | undefined) => {
    return value ? `${key}: ${value}\n` : ''
  }

  const prev =
    show('Validity', row.description.validity?.prev) +
    show('Description', row.description.description?.prev) +
    show('Circles', row.description.circles?.prev)

  const newData =
    show('Validity', row.description.validity?.current) +
    show('Description', row.description.description?.current) +
    show('Circles', row.description.circles?.current)

  return {
    prev,
    newData,
  }
}
